import { createGlobalStyle } from "styled-components";
import { media } from "./responsive";

export const GlobalStyles = createGlobalStyle`
/* Base styling */
body {
  background: ${({ theme }) => theme.body};
  color: ${({ theme }) => theme.text};
  font-family: ibm-plex-sans, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  transition: all 0.25s linear;
  font-size: 23px;
}

/* Bootstrap overrides */
.bg-primary {
  background-color: ${({ theme }) => theme.button.primary_color} !important;
}

.text-primary {
  color: ${({ theme }) => theme.button.primary_color} !important;
}

.border-primary {
  border-color: ${({ theme }) => theme.button.primary_color} !important;
}

/* Button styling */
.btn {
  box-shadow: none;
  &-primary {
    background-color: ${({ theme }) => theme.button.primary_color};
    border-color: ${({ theme }) => theme.button.primary_border_color};
    &:focus {
      color: #ffffff;
      background-color: ${({ theme }) => theme.button.primary_color};
      border-color: ${({ theme }) => theme.button.primary_border_color};
      box-shadow: none;
      outline: none;
    }
    &:hover,
    &:not(:disabled):not(.disabled):active {
      color: #ffffff;
      background-color: ${({ theme }) => theme.button.primary_color};
      border-color: ${({ theme }) => theme.button.primary_border_color};
    }
  }
  
  &-outline-primary {
    color: ${({ theme }) => theme.button.primary_color};
    border-color: ${({ theme }) => theme.button.primary_color};
    
    &:hover, &:focus, &:active {
      background-color: ${({ theme }) => theme.button.primary_color};
      border-color: ${({ theme }) => theme.button.primary_color};
    }
  }
}

/* Grid and layout components */
.react-grid-item {
  &:hover {
    .resizer {
      opacity: 1;
    }
    .drag-handle {
      display: block;
      cursor: grab;
      &:active {
        cursor: grabbing;
      }
    }
    .react-resizable-handle {
      opacity: 0;
    }
  }
}
.resizer {
  opacity: 0;
}
.drag-handle {
  display: none;
  position: absolute;
  top: -17px;
  left: -9px;
  z-index: 1;
  > svg {
    fill: #5f5f5f;
    background: #D2D2D2;
    width: 30px;
    height: 30px;
    padding: 3px;
    border-radius: 25px;
  }
}
.react-resizable-handle {
  opacity: 0;
}

/* Dropdown styling */
.show > .dropdown-toggle {
  background-color: ${({ theme }) => theme.button.primary_color};
  border-color: ${({ theme }) => theme.button.primary_border_color};
}
.dropdown-menu {
  color: ${({ theme }) => theme.text};
  background-color: ${({ theme }) => theme.dropdown.background_color};
}
.dropdown-item {
  color: ${({ theme }) => theme.text};
  
  &:hover, &:focus {
    background-color: ${({ theme }) => 
      theme.mode === 'light' ? 'rgba(13, 138, 106, 0.1)' : 'rgba(13, 138, 106, 0.2)'};
  }
  
  &.active, &:active {
    background-color: ${({ theme }) => theme.button.primary_color};
  }
}

/* Date picker */
.react-datepicker {
  font-family: ibm-plex-sans, 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

/* Charts */
.echarts-for-react {
  > div > svg > rect {
    fill: rgb(255,255,255,0);
  }
}

/* Modal styling */
.modal {
  .custom {
    .modal-content {
      border-radius: 0 !important;
      box-sizing: border-box;
      border: 0;
      background: ${({ theme }) => theme.modal.background};
    }

    &.curved,
    &.curved-wide {
      .modal-content {
        border-radius: 20px !important;
        box-sizing: border-box;
        border: 0;
      }
    }

    &.curved-wide {
      width: 80vw;
      max-width: none !important;
    }
  }
  
  .curved-wide-report {
    max-width: 90vw;
    height: 90vh;
    .modal-content {
      width: 100%;
      height: 100%;
      max-width: none !important;
      border-radius: 25px !important;
    }
  }
  .extended-a-report {
    max-width: 90vw;
    .modal-content {
      width: 100%;
      height: 100%;
      max-width: none !important;
      border-radius: 25px !important;
      .modal-header {
        height: 60px;
        border-bottom: none;
      }
      .modal-body {
        height: 90vh;
        padding-top: 0px;
      }
    }
  }

  .ext-a-saved-views {
    transform: translate(0, 50%) !important;
    max-width: 60vw;
    height: 20vh;
    .modal-content {
      background-color: ${({ theme }) => theme.modal.background};
      width: 100%;
      max-width: none !important;
      border-radius: 20px !important;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
      .modal-header {
        height: 60px;
        border-bottom: none;
      }
      .modal-body {
        padding-top: 0px;
        padding-left: 11px;
        padding-right: 11px;
      }
    }
  }

  .ext-a-save-current-view {
    transform: translate(0, 50%) !important;
    max-width: 40vw;
    height: 20vh;
    .modal-content {
      background-color: ${({ theme }) => theme.modal.background};
      width: 100%;
      max-width: none !important;
      border-radius: 20px !important;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
      .modal-header {
        height: 60px;
        border-bottom: none;
      }
      .modal-body {
        padding-top: 0px;
        padding-left: 11px;
        padding-right: 11px;
      }
    }
  }

  .ext-a-calculated-field {
    transform: translate(0, 50%) !important;
    max-width: 40vw;
    height: 20vh;
    .modal-content {
      background-color: ${({ theme }) => theme.modal.background};
      width: 100%;
      max-width: none !important;
      border-radius: 20px !important;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
      .modal-header {
        height: 60px;
        border-bottom: none;
      }
      .modal-body {
        padding-top: 0px;
        padding-left: 11px;
        padding-right: 11px;
      }
    }
  }

  .close-modal-btn {
    cursor: pointer;
    z-index: 1;
    position: absolute;
    top: -20px;
    right: -20px;
    border-radius: 20px;
    width: 50px;
    height: 50px;
    background-color: #fff;
    > svg {
      fill: "#212121" !important;
    }

    .modal-body {
      overflow-y: scroll;
    }
  }
  .company-switch-dialog {
    .modal-content {
      background-color: ${({ theme }) => theme.modal.background};
      border-radius: 30px;
    }
  }

  .sub-r-custom-inventory-modal {
    max-width: 1004px;
    max-height: 731px;
    .modal-content {
      width: 100%;
      height: 100%;
      max-width: none !important;
      border-radius: 20px !important;
      border: 1px solid ${({ theme }) => theme.border_color};
    }
  }
}

/* Popover styles */
.company-name-popover {
  max-width: 600px;
  .popover-body {
    text-align: center;
  }
}

/* Card styles */
.card {
  background-color: ${({ theme }) => theme.widget.background};
  border-color: ${({ theme }) => theme.border_color};
}

/* Table styles */
.table {
  color: ${({ theme }) => theme.text};
  
  thead {
    background-color: ${({ theme }) => theme.widget.tableHeader};
  }
}

/* Form controls */
.form-control {
  background-color: ${({ theme }) => 
    theme.mode === 'light' ? '#ffffff' : '#333333'};
  color: ${({ theme }) => theme.text};
  border-color: ${({ theme }) => theme.border_color};
  
  &:focus {
    background-color: ${({ theme }) => 
      theme.mode === 'light' ? '#ffffff' : '#333333'};
    color: ${({ theme }) => theme.text};
  }
}

.input-group-text {
  background-color: ${({ theme }) => 
    theme.mode === 'light' ? '#e9ecef' : '#444444'};
  border-color: ${({ theme }) => theme.border_color};
  color: ${({ theme }) => theme.text};
}

/* Enhanced Sidebar styling with proper theming */
.sidebar-menu {
  max-width: 380px;
  width: 380px;
  background-color: #212529;
  border-left: 1px solid #494c52;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);

  .sidebar-header {
    padding: 20px;
    border-bottom: 1px solid #494c52;
    background: #212529;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 80px;

    .sidebar-brand {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;

      .sidebar-logo {
        display: flex;
        align-items: center;
        justify-content: center;

        img,
        svg {
          max-height: 32px;
          width: auto;
        }
      }

      .sidebar-company-name {
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 180px;
      }
    }

    .custom-close-btn {
      background: none;
      border: none;
      color: #fff;
      padding: 8px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
      opacity: 0.7;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        opacity: 1;
        transform: scale(1.05);
      }

      &:focus {
        outline: 2px solid #0d8a6a;
        outline-offset: 2px;
      }
    }
  }

  .sidebar-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 160px);

    .navigation-section {
      flex: 1;
      padding: 24px 0;

      .section-title {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: rgba(255, 255, 255, 0.6);
        margin: 0 20px 16px 20px;
        padding-bottom: 8px;
        border-bottom: 1px solid #494c52;
      }

      .sidebar-nav {
        width: 100%;
        gap: 4px;
        padding: 0 12px;

        .nav-item {
          padding: 0;
          margin: 0;
          border-radius: 12px;
          transition: all 0.25s ease;
          position: relative;
          overflow: hidden;

          &:hover {
            background-color: rgba(255, 255, 255, 0.1);
            transform: translateX(4px);
          }

          &.active {
            background: linear-gradient(
              135deg,
              rgba(13, 138, 106, 0.15),
              rgba(13, 138, 106, 0.08)
            );
            border: 1px solid rgba(13, 138, 106, 0.3);
            transform: translateX(8px);

            .nav-item-title {
              color: #0d8a6a;
              font-weight: 600;
            }

            .nav-item-indicator {
              opacity: 1;
            }
          }

          .nav-item-container {
            padding: 14px 20px;
            position: relative;

            .nav-item-content {
              display: flex;
              align-items: center;
              gap: 16px;

              .nav-item-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 32px;
                height: 32px;
                background-color: rgba(255, 255, 255, 0.1);
                border-radius: 8px;
                transition: all 0.2s ease;

                svg {
                  width: 18px;
                  height: 18px;
                  transition: transform 0.2s ease;
                }
              }

              .nav-item-text {
                flex: 1;

                .nav-item-title {
                  font-size: 15px;
                  font-weight: 500;
                  color: #fff;
                  transition: color 0.2s ease;
                }
              }
            }

            .nav-item-indicator {
              position: absolute;
              right: 0;
              top: 0;
              width: 4px;
              height: 100%;
              background: #0d8a6a;
              border-radius: 0 2px 2px 0;
              opacity: 0;
              transition: opacity 0.2s ease;
            }
          }

          &:hover .nav-item-icon {
            background-color: rgba(13, 138, 106, 0.2);
          }

          &:hover .nav-item-icon svg {
            transform: scale(1.1);
          }

          &.active .nav-item-icon {
            background-color: rgba(13, 138, 106, 0.3);
          }
        }
      }
    }
  }

  .sidebar-footer {
    padding: 20px;
    border-top: 1px solid #494c52;
    background: #212529;
    margin-top: auto;

    .footer-content {
      .theme-section {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .theme-label {
          font-size: 14px;
          font-weight: 500;
          color: #fff;
        }
      }
    }
  }
}
/* Responsive improvements for sidebar */
${media.down.xs} {
  .sidebar-menu {
      max-width: 100vw;
      width: 100vw;

      .sidebar-header {
        padding: 16px;
        min-height: 70px;

        .sidebar-brand {
          gap: 8px;

          .sidebar-company-name {
            font-size: 14px;
            max-width: 140px;
          }
        }
      }

      .sidebar-body {
        height: calc(100vh - 140px);

        .navigation-section {
          padding: 16px 0;

          .section-title {
            margin: 0 16px 12px 16px;
            font-size: 11px;
          }

          .sidebar-nav {
            padding: 0 8px;

            .nav-item {
              border-radius: 8px;

              .nav-item-container {
                padding: 12px 16px;

                .nav-item-content {
                  gap: 12px;

                  .nav-item-text {
                    .nav-item-title {
                      font-size: 14px;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .sidebar-footer {
        padding: 16px;
      }
    }
}
${media.down.xxs} {
    .sidebar-menu {
      .sidebar-header {
        .sidebar-brand {
          .sidebar-company-name {
            max-width: 120px;
            font-size: 13px;
          }
        }
      }
    }
  }
  /* Animation enhancements */
  .sidebar-menu {
    transform: translateX(100%);
    transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

    &.show {
      transform: translateX(0);
    }
  }

    /* Dark mode specific adjustments */
    @media (prefers-color-scheme: dark) {
    .sidebar-menu {
      box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
    }
  }

    /* Focus management for accessibility */
    .sidebar-menu {
    &:focus-within {
      .sidebar-nav .nav-item:focus-visible {
        outline: 2px solid ${(props) => props.theme.primary_color};
        outline-offset: 2px;
        border-radius: 8px;
      }
    }
  }
`;
